import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Container, Button, TextField, MenuItem, DialogActions, Card, Grid, Typography, } from "@mui/material";
// import { format } from "date-fns";
import HeaderSession from "../../../utils/headerSession";
import api from "../../../services/api";
import FazerObservacoes from "../../components/fazerObservacoes.";
import MessageError from "../../../messages/messageError";
import MessageSuccess from "../../../messages/messageSuccess";
// import Loading from "../../../load/loading";
import { useSelector } from "react-redux";
import LoadingShort from "../../../load/loadingShort";
import ObservacoesFeitas from "../../departamentos/dlif/observacoesFeitas";
import DocumentViewer from "../../departamentos/dmts/importacaoExportacao/documentViewer";
import HeaderGestorConfigs from "../../../utils/headerGestorConfigs";
import StatusSolicitacoes from "../../../utils/status/statusSolicitacoes";
import InfoFieldGroup from "../../../utils/InfoField/InfoFieldGroup";
import DateHora from "../../../utils/dateHora";
import { makeStyles } from "@material-ui/core";
import ProcessoLoading from "../../../load/processoLoading";
// import VerifyPermission from "../../../utils/verifyPermission";

const useStyles = makeStyles((theme) => ({
  grid1: {
    width: 300,
    marginLeft: "auto",
    marginRight: "auto",

    [theme.breakpoints.up("md")]: {
      // width: '100%',
      height: "100%",
      position: "sticky",
      top: 70,
    },
  },
  grid2: {
    flexGrow: 1,
    marginLeft: 15,
    width: 500,
    zIndex: 1,
  },
}));

interface Medicamento {
  status: string;
  nome: string;
  numeroRegisto: string;
  dciDosagem: string;
  apresentacao: string;
  areaTerapeutica: string;
  fabricante: string;
  titularAIM: string;
  createdAt: string;
  docs: [];
  observacoes: {
    length: number;
  };
}

const estados = ["Análise", "Aprovado", "Suspenso", "Reprovado", "Cancelado", "Retirado do Mercado"];

const MedicamentoDetalhe: React.FC = () => {
  const classes = useStyles();
  const user = useSelector((state: any) => state?.account.user);
  const [medicamento, setMedicamento] = useState<Medicamento>();
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadStatus, setStatus] = useState(false);
  const [loadObs, setLoadObs] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [obs, setObs] = useState("");
  const [estado, setEstado] = useState("");
  const { id } = useParams();

  useEffect(() => {
    setIsLoading(true);
    api.get(`/medicamento-aim/${id}`)
      .then((res) => {
        setMedicamento(res.data.medicamentoAIM)
      }).catch((err) => {
      }).finally(() => setIsLoading(false))
  }, [refreshPage, estado, IDBCursor])

  if (!medicamento) {
    return (
      <Box textAlign="center">
        <HeaderSession title="DETALHES DO MEDICAMENTO" />
        <ProcessoLoading />
      </Box>
    );
  }


  // const coresEstado: Record<string, string> = {
  //   "Análise": "#515151",
  //   "Aprovado": "#2e7d32",
  //   "Suspenso": "#ed6c02",
  //   "Reprovado": "#d32f2f",
  // };


  const handleChangeStatus = () => {
    setStatus(true);
    api.patch("/medicamento-aim/change-status", {
      medicamentoAIMId: id,
      status: estado,
      observacao: '',
      userId: user?._id
    })
      .then(() => {
        setSuccess("Estado actualizado!");
        setRefreshPage((prev) => !prev);
        setEstado("");
      })
      .catch((err) => {
        setError(err?.response?.data?.message);
      }).finally(() => setStatus(false));
  };

  const handleObservacao = () => {
    setLoadObs(true);
    api.patch("/medicamento-aim/add-observacao", {
      medicamentoAIMId: id,
      content: obs,
      userId: user?._id
    })
      .then(() => {
        setSuccess("Observação adicionada!");
        setRefreshPage((prev) => !prev)
        setObs("");
      })
      .catch((err) => {
        setError(err?.response?.data?.message);
      }).finally(() => setLoadObs(false));
  };

  // temporio para teste de permissões, depois retirar
  const isAuthorized = user?.permissions?.includes('gerenciarEstadoMedicamento') || user?.permissions?.includes('allPermissions');

  return (
    <Container
      // maxWidth="md"
      sx={{ display: "flex", flexDirection: "column", }}>
      <HeaderSession title="DETALHES DO MEDICAMENTO" />

      <Grid container>
        <Grid item className={classes.grid1}>
          <Card sx={{ padding: 2 }}>

            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", placeItems: 'center' }}>
              <img src="/icones/Medicamentos_autorizados.svg" alt="img" width={'60%'} />
              {/* <img src="/icones/Medicamentos.svg" alt="img" width={'100%'} /> */}
            </div>

            <Typography align="center">
              Estado do Medicamento
              <br />
              <b>{medicamento.status} </b>
            </Typography>
          </Card>
          <br />
          {medicamento.observacoes.length > 0 && <ObservacoesFeitas observacoesFeitas={medicamento.observacoes} />}

        </Grid>

        <Grid xs item className={classes.grid2} style={{ marginLeft: 15 }}>

          {/* MELHORAR AQUI DEPOIS, APLICAR O VERIFYPERMISSION MESMO  */}
          {/* <VerifyPermission permissions={user?.permissions} permission={'gerenciarEstadoMedicamento'}> */}
          {isAuthorized &&
            <Card sx={{ padding: 2, mb: 2 }}>
              <HeaderGestorConfigs title='Gestão de Estado' />

              {error && (<MessageError message={error} />)}
              {success && <MessageSuccess message={success} />}

              <TextField
                label="Estado do Medicamento"
                select
                size="small"
                defaultValue={medicamento?.status}
                onChange={(e) => setEstado(e.target.value)}
                fullWidth
              >
                {estados.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>

              {estado &&
                <>
                  <FazerObservacoes
                    setObs={setObs}
                    obs={obs}
                    titulo="(Descreve aqui as observaçōes"
                  />
                  <DialogActions>
                    <Button variant="outlined"
                      color="error"
                      onClick={() => {
                        setEstado("");
                        setObs("");
                      }}>Cancelar</Button>
                    <Button disabled={!obs} style={{ backgroundColor: '#85287e' }} variant="contained"
                      onClick={() => { handleChangeStatus(); handleObservacao(); }}>{loadObs ? <LoadingShort text={''} /> : "Salvar"}</Button>
                  </DialogActions>
                </>
              }
            </Card>
          }
          {/* </VerifyPermission> */}

          <Card sx={{ padding: 2 }}>

            <HeaderGestorConfigs title='Informações Gerais' />

            <InfoFieldGroup
              // submit={submitEdit}
              // data={editDados}
              // handleChange={() => { } } 
              setIsEdit={undefined}
              isEdit={false}
              load={false}
              fields={
                [
                  { label: 'Estado', value: <StatusSolicitacoes status={medicamento?.status} />, key: 'status', onChange: (v) => 'setEditDados({ ...editDados, status: v.target.value })' },
                  { label: 'Número de Registo', value: medicamento?.numeroRegisto, key: 'numeroRegisto', onChange: (v) => 'setEditDados({ ...editDados, numeroRegisto: v.target.value })' },
                  { label: 'DCI - Dosagem', value: medicamento?.dciDosagem, key: 'dciDosagem', onChange: (v) => 'setEditDados({ ...editDados, dciDosagem: v.target.value })' },
                  { label: 'Apresentação', value: medicamento?.apresentacao, key: 'apresentacao', onChange: (v) => 'setEditDados({ ...editDados, apresentacao: v.target.value })' },
                  { label: 'Área Terapêutica', value: medicamento?.areaTerapeutica, key: 'areaTerapeutica', onChange: (v) => 'setEditDados({ ...editDados, areaTerapeutica: v.target.value })' },
                  { label: 'Fabricante', value: medicamento?.fabricante, key: 'fabricante', onChange: (v) => 'setEditDados({ ...editDados, fabricante: v.target.value })' },
                  { label: 'Titular AIM', value: medicamento?.titularAIM, key: 'titularAIM', onChange: (v) => 'setEditDados({ ...editDados, titularAIM: v.target.value })' }, { label: 'Data de Registo', value: <DateHora date={medicamento?.createdAt} />, key: 'createdAt', onChange: (v) => 'setEditDados({ ...editDados, createdAt: v.target.value })' },
                ]
              } />
          </Card>

          <br />
          {medicamento?.docs &&
            <Card style={{ padding: 20 }}>
              <DocumentViewer urlApi={''} entidade={''} pdfUrls={medicamento?.docs} />
            </Card>
          }
          {/* </Card> */}

        </Grid>
      </Grid>
    </Container >

  );
};

export default MedicamentoDetalhe;
